import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import "../../style.css";


function Home() {
  // Function to handle the button click and redirect to the specified URL
  return (
    
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                <span className="hover-greeting" data-hover="Vanakkam (Welcome in Tamil)">வணக்கம்{" "}</span>
                <span className="wave" role="img" aria-labelledby="wave">
                  🙏
                </span>
              </h1>

              <h1 className="heading-name">
                <strong className="main-name"> Varshini here!</strong>
              </h1>

              <div style={{ padding: "30px 0 0" }}>
                <Type />                                
              </div>
              
            </Col>
            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
